import {Component, Inject, OnInit, ViewChild} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {Product} from "../../../../model/product";
import {Property} from "../../../../model/property";
import ProductUtils from "../../../../utils/product-utils";
import {FolioNumberComponent} from "../../../folio-number/folio-number.component";
import {LandregisterfolioUtils} from "../../../../utils/LandregisterfolioUtils";

@Component({
  selector: 'app-bewil-information',
  templateUrl: './bewil-information.component.html',
  styleUrls: ['./bewil-information.component.css']
})
export class BewilInformationComponent implements OnInit{

  bewilProduct: Product;
  selectedProperty: Property;

  @ViewChild(FolioNumberComponent) folioNumberComponent: FolioNumberComponent;

  protected readonly ProductUtils = ProductUtils;

  constructor(public dialogRef: MatDialogRef<BewilInformationComponent>, @Inject(MAT_DIALOG_DATA) public data: any) {
  }

  ngOnInit(): void {
    this.bewilProduct = this.data?.products?.[0] ?? undefined;
    this.selectedProperty = this.data?.selectedProperty ?? undefined;
  }

  /**
   * Adds a Bewil document by validating the folio number form, assigning folio numbers,
   * and updating the selected property with necessary data.
   * Closes the dialog upon successful execution.
   */
  public addBewilDocument(): void {
    // Checks if the forms are valid. If not automatically marks all invalid inputs
    const isFolioNumberFormValid = this.folioNumberComponent?.isFolioNumberFormValid();

    if (!isFolioNumberFormValid) {
      return;
    }

    const formValues = this.folioNumberComponent.folioNumberForm.get('numbers')?.value ?? [];

    LandregisterfolioUtils.createFoliosIfMissing(this.selectedProperty);
    LandregisterfolioUtils.assignFolioNumbers(this.selectedProperty.landregisterfolios, formValues);
    this.selectedProperty.dataResearch = this.folioNumberComponent.folioNumberForm.get('dataResearch')?.value ?? false;

    this.dialogRef.close(true);
  }

  /**
   * Closes the currently open modal dialog.
   */
  public closeModal(): void {
    this.dialogRef.close(false);
  }
}
